/**
 * Decode a JWT token payload without a library.
 * Returns the parsed payload object, or null on failure.
 */
export function decodeToken(token) {
  try {
    const payload = token.split('.')[1];
    // Base64url → Base64
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

/**
 * Returns true if the token is missing, malformed, or its exp has passed.
 */
export function isTokenExpired(token) {
  const decoded = decodeToken(token);
  if (!decoded?.exp) return true;
  return Math.floor(Date.now() / 1000) >= decoded.exp;
}
